import React, { useState } from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import Caps from '../../assets/images/caps.svg';
import Preforms from '../../assets/images/preforms.svg';
import Bottles from '../../assets/images/bottles.svg';
import BrownCap from '../../assets/images/caps/28mmbrownplain.jpg';
import GreeenCap from '../../assets/images/caps/28mmhdpegreennoncarbonated.jpg';
import FineGreenCap from '../../assets/images/caps/28mmlemongreen.jpg';
import OrangeCap from '../../assets/images/caps/28mmorangeplain.jpg';
import YellowCap from '../../assets/images/caps/28mmyellowhpde.jpg';
import DeepBlueCap from '../../assets/images/caps/30mmdeepblue.jpg';
import SkyBlueCap from '../../assets/images/caps/30mmskyblue.jpg';
import WhiteCap from '../../assets/images/caps/30mmwhiteHDPE.jpg';

const Products = () => {
  const { width } = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const colors = [
    {
      name: 'brown',
      hex: '#AD5233',
      image: BrownCap,
    },
    {
      name: 'green',
      hex: '#3ACC89',
      image: GreeenCap,
    },
    {
      name: 'fine green',
      hex: '#8BE655',
      image: FineGreenCap,
    },
    {
      name: 'orange',
      hex: '#FD7F2E',
      image: OrangeCap,
    },
    {
      name: 'yellow',
      hex: '#FDDC02',
      image: YellowCap,
    },
    {
      name: 'deep blue',
      hex: '#0E46A7',
      image: DeepBlueCap,
    },
    {
      name: 'sky blue',
      hex: '#5BDAFA',
      image: SkyBlueCap,
    },
    {
      name: 'white',
      hex: '#FAFAFA',
      image: WhiteCap,
    },
  ];

  return (
    <div className="container-fluid bg-warning" style={{ paddingTop: '5rem' }}>
      <div className="container">
        <p className="text-center text-secondary">
         Get to know about 
        </p>
        <h1 className="text-center text-info">
          <strong>Our Products</strong>
        </h1>
        <div className="row justify-content-center align-items-center mt-5">
          <div className="col-12 col-md-4 mb-5">
            <div className="bg-white rounded-1 overflow-hidden">
              <div className="image-container">
                <img src={Caps} alt="Caps" width="100%" height="200px" style={{ objectFit: 'cover', objectPosition: 'center' }} />
              </div>
              <div className="px-3 py-3">
                <h5 className="text-info mb-0">
                  HDPE Caps
                </h5>
                <div className="bg-danger mb-3" style={{ width: '53px', height: '1px' }}></div>
                  <p className="text-secondary">
                    HDPE (High Density Polyethylene) is a primary packaging option for a lot of industries. We supply caps of different variants.
                  </p>
                  <p className="text-end text-primary" style={{ cursor: 'pointer' }} onClick={() => setIsOpen(state => !state)}>
                    { isOpen ? 'Hide Caps' : 'Show Caps' }
                  </p>
                </div>
              </div>
              { width < 700 && isOpen && (<table className="bg-white rounded-1 mt-3 p-5 text-center">
                <thead>
                  <tr>
                    <td>
                      <p className="text-secondary font-weight-bold">
                        Product Photo
                      </p>
                    </td>
                    <td>
                      <p className="text-secondary font-weight-bold">
                        Product Size
                      </p>
                    </td>
                    <td>
                      <p className="text-secondary font-weight-bold">
                        Product Color
                      </p>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <img src={colors[activeIndex].image} className="img-fluid" width="100px" alt="Cap" />
                    </td>
                  <td>
                    <p className="text-info font-weight-bold">
                      <strong>28mm / 30mm</strong>
                    </p>
                  </td>
                  <td>
                    <div>
                      <div className="d-flex justify-content-center align-items-center">
                        { colors.map((color, index) => (
                          <div className="rounded-circle" style={{
                            backgroundColor: color.hex,
                            border: index === activeIndex ? '3px solid #0D0A2E': '',
                            width: '10px',
                            height: '10px',
                            marginRight: '12px'
                          }} onClick={() => setActiveIndex(index)}></div>
                        ))}
                      </div>
                      <p className="text-info text-capitalize mt-3">
                        <strong>
                          { colors[activeIndex].name }
                        </strong>
                      </p>
                    </div>
                  </td>
                  </tr>
                </tbody>
              </table>)}
          </div>
          <div className="col-12 col-md-4 mb-5">
            <div className="bg-white rounded-1 overflow-hidden">
              <div className="image-container">
                <img src={Preforms} alt="Caps" width="100%" height="200px" style={{ objectFit: 'cover', objectPosition: 'center' }} />
              </div>
              <div className="px-3 py-3">
                <h5 className="text-info mb-0">
                  Preforms
                </h5>
                <div className="bg-danger mb-3" style={{ width: '53px', height: '1px' }}></div>
                <p className="text-secondary">
                  Preforms are intermediate products from resin that is subsequently blown into a Polyethylene terephthalate(PET) container. 
                </p>
                <p className="text-end text-primary">
                  &nbsp;
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 mb-5">
            <div className="bg-white rounded-1 overflow-hidden">
              <div className="image-container">
                <img src={Bottles} alt="Caps" width="100%" height="200px" style={{ objectFit: 'cover', objectPosition: 'center' }} />
              </div>
              <div className="px-3 py-3">
                <h5 className="text-info mb-0">
                  Bottles
                </h5>
                <div className="bg-danger mb-3" style={{ width: '53px', height: '1px' }}></div>
                <p className="text-secondary">
                  Preforms are extruded or moulded into plastic bottles. Bottles are for packaging water, beverages, personal care products, etc.
                </p>
                <p className="text-end text-primary">
                  &nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
        { width > 700 && isOpen && (<table className="bg-white rounded-1 p-5 text-center" style={{ width: '60vw'}}>
          <thead>
            <tr>
              <td>
                <p className="text-secondary font-weight-bold">
                  Product Photo
                </p>
              </td>
              <td>
                <p className="text-secondary font-weight-bold">
                  Product Size
                </p>
              </td>
              <td>
                <p className="text-secondary font-weight-bold">
                  Product Color
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <img src={colors[activeIndex].image} className="img-fluid" width="100px" alt="Cap" />
              </td>
            <td>
              <p className="text-info font-weight-bold">
                <strong>28mm / 30mm</strong>
              </p>
            </td>
            <td>
              <div>
                <div className="d-flex justify-content-center align-items-center">
                  { colors.map((color, index) => (
                    <div className="rounded-circle" style={{
                      backgroundColor: color.hex,
                      border: index === activeIndex ? '3px solid #0D0A2E': '',
                      width: '24px',
                      height: '24px',
                      marginRight: '12px'
                    }} onClick={() => setActiveIndex(index)}></div>
                  ))}
                </div>
                <p className="text-info text-capitalize mt-3">
                  <strong>
                    { colors[activeIndex].name }
                  </strong>
                </p>
              </div>
            </td>
            </tr>
          </tbody>
        </table>)}
      </div>
    </div>
  );
};

export { Products };
